module.exports = __webpack_public_path__ + "static/media/ic_audio_disable.53158cf3.svg";